<template>
  <div class="mgt-20px">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-error" @click="retour">
              {{ $t('general.button.cancel') }}
            </button>
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :actions="actionSecondary"
              @click="ouverturePopUp">
                {{ $t('general.button.sauvegarder') }}
            </dropdownButton>
            <piece-jointe-button
              class="mgr-2"
              :perm="permEmplacement.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'InfoGenerale'}"
            @click="activeTab = 'InfoGenerale'">
            {{ $t('clientEmplacement.infoGeneral') }}
          </li>
          <li :class="{'is-active': activeTab === 'InfoTechnique'}"
            @click="activeTab = 'InfoTechnique'">
            {{ $t('clientEmplacement.infoTechnique') }}
          </li>
        </ul>
      </div>
      <error-msg-component
        :messages="messages"
        :error="error" class="mgt-20px"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="error = $event"
      />
      <component
        v-if="isLoad"
        :is="activeTab"
        :emplacement="emplacement"
        :emplacementTechniqueInformation="emplacement.emplacementTechnique"
      />
    <b-modal v-model="popUpChangementAdresseDispositifProduit"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('emplacement.popUpChangementInDispositifProduit.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="saveEmplacement(false)"
        @yes="saveEmplacement(true)">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererEmplacementClient from '@/services/gabed/emplacement/client/genererEmplacementClient';
import dropdownButton from '@/components/general/button/dropdownButton';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import translate from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import messageSucces from '@/services/general/messageSucces';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { get, update, create } from '@/api/gabed/emplacement/emplacementClient';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import InfoGenerale from '@/components/gabed/emplacement/client/m_infoGenerale';
import InfoTechnique from '@/components/emplacementTechnique/m_infoTechnique';
import informationsGenerationCode from '@/components/gabed/emplacement/informationsGenerationCodeEmplacement';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import breadcrumb from '@/components/general/breadcrumb';

const Attachments = createNamespacedHelpers('attachments');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'm_emplacementClient',
  data() {
    return {
      activeTab: 'InfoGenerale',
      appBreadcrumb: breadcrumb,
      emplacement: genererEmplacementClient(),
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      permEmplacement: EMPLACEMENT,
      popUpChangementAdresseDispositifProduit: false,
      oldAdresse: null,
      code: '',
      isLoad: false,
      prevRoute: null,
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationGeneral(this.$i18n, response, this.champsVide, this.messages,
        this.messagesChampsVide, translate);
      validationPatrimoine(response, this.messages);
      this.error = true;
    },
    async retour() {
      if (this.prevRoute?.name === 'm.gabed.emplacement-ajoutEmplacement') {
        await this.$router.replace({ name: 'm.gabed.emplacement-ajoutEmplacement' });
      } else {
        await this.$router.go(-1);
      }
    },
    ouverturePopUp() {
      if (!this.$route.params.id) {
        this.saveEmplacement(false);
        return;
      }
      if (JSON.stringify(this.oldAdresse) !== JSON.stringify(this.emplacement.adresseCadastrale)) {
        if (this.majAutoAdresseCommercialeAvecEnAllantVers) this.saveEmplacement(true);
        else this.popUpChangementAdresseDispositifProduit = true;
        return;
      }
      this.saveEmplacement(false);
    },
    async saveEmplacement(updateAdresse) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.popUpChangementAdresseDispositifProduit = false;
        let clientEmplacement;
        if (this.$route.params.id) {
          this.emplacement.synchroniserAdresse = updateAdresse;
          clientEmplacement = (await update(this.emplacement)).data.result;
          await this.updateAttachments(this.emplacement.id);
          messageSucces(this.$t('clientEmplacement.save'));
        } else {
          this.emplacement.societeId = this.societeActiveId;
          clientEmplacement = (await create(this.emplacement)).data.result;
          await this.setAttachmentElementId({ id: clientEmplacement.id });
          await this.insertAttachments(clientEmplacement.id);
          messageSucces(this.$t('clientEmplacement.success'));
        }
        loadingComponent.close();
        if (this.prevRoute?.name === 'm.gabed.emplacement-ajoutEmplacement') {
          await this.$router.replace({
            name: 'c.gabed.emplacement-client',
            params: { id: clientEmplacement.id },
          });
        } else {
          this.$router.go(-1);
        }
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    getTitle() {
      return this.$route.params.id ? this.$i18n.t('clientEmplacement.titleModification',
        { code: this.code }) : this.$i18n.t('clientEmplacement.title');
    },
    majAutoAdresseCommercialeAvecEnAllantVers() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.majAutoAdresseCommercialeAvecEnAllantVers.key,
      );
    },
    actionSecondary() {
      const actions = [];

      if (this.$route.params.id) {
        actions.push(
          {
            label: this.$t('emplacement.actions.saveWithoutUpdateDispositifAndMateriel'),
            action: () => { this.saveEmplacement(false); },
          },
          {
            label: this.$t('emplacement.actions.saveWithUpdateDispositifAndMateriel'),
            action: () => { this.saveEmplacement(true); },
          },
        );
      }
      return actions;
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        {
          title: this.$i18n.t('detailEmplacement.titleWithoutN'),
          route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.$route.params.id } },
          isActive: false,
        },
        { title: this.$i18n.t('detailEmplacement.types.client'), route: '', isActive: true },
      ];
      if (!this.$route.params.id) {
        output.splice(2, 1);
      }
      return output;
    },
  },
  components: {
    appBreadcrumb: breadcrumb,
    errorMsgComponent,
    dropdownButton,
    informationsGenerationCode,
    popUpPrevention,
    InfoGenerale,
    InfoTechnique,
    pieceJointeButton,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'EmplacementClient' });
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.majAutoAdresseCommercialeAvecEnAllantVers.key]);
      if (this.$route.params.id) {
        this.emplacement = (await get(this.$route.params.id)).data.result;
        this.oldAdresse = cloneDeep(this.emplacement.adresseCadastrale);
        this.code = cloneDeep(this.emplacement.code);
        await this.setAttachmentElementId({ id: this.emplacement.id });
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.emplacement.code }));
      } else this.setInformationPage(this.$t('pagePatrimoine.emplacement.adresse.creation'));
      this.isLoad = true;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
